module.exports = Immutable;


//////////////////
// WEBPACK FOOTER
// external "Immutable"
// module id = 4
// module chunks = 0 2 3